
  import { Component, Prop, Vue }          from 'vue-property-decorator';
  import { ConfigService,
           ConfigThemeService,
           ResponsiveUiHelper,
           EventBus }                      from '../..';


  @Component({
    name: 'TablePlaceholderComponent',
  })
  export default class TablePlaceholderComponent extends Vue {
    @Prop() btnPlaceholderId!: string;
    @Prop() iconPlaceholderId!: string;
    @Prop() vuetifyRef!: any;

    isFullscreenDisplay: boolean = false;

    get placeholderSize() {
      // TRUE when less than low resolution tablet display, FALSE otherwise
      return (this.isFullscreenDisplay) ? '60' : '120';
    }

    get placeholderTextContainerStyle(){
      return { minHeight: this.placeholderSize+"px" }
    }

    get placeholderColor() {
      return ConfigThemeService.getMessageBoxPlaceholderColor(this.vuetifyRef);
    }

    get placeholderIcon() {
      return ConfigThemeService.getMessageBoxPlaceholderIcon();
    }

    get placeholderButtonStyles() {
      return ConfigThemeService.getMessageBoxPlaceholderButtonStyles(this.vuetifyRef);
    }

    get isRoundedPlaceholderButtonsShapeActive() {
      return (ConfigThemeService.getPlaceholderButtonsShape() && ConfigThemeService.getPlaceholderButtonsShape() === 'rounded');
    }

    get isOutlinedPlaceholderButtonsShapeActive() {
      return (ConfigThemeService.getPlaceholderButtonsShape() && ConfigThemeService.getPlaceholderButtonsShape() === 'outlined');
    }

    get isDepressedPlaceholderButtonsShapeActive() {
      return (ConfigThemeService.getPlaceholderButtonsShape() && ConfigThemeService.getPlaceholderButtonsShape() === 'depressed');
    }

    get isTilePlaceholderButtonsShapeActive() {
      return (ConfigThemeService.getPlaceholderButtonsShape() && ConfigThemeService.getPlaceholderButtonsShape() === 'tile');
    }

    get placeholderText() {
      return ConfigService.getMessageBoxPlaceholderIntroText();
    }

    get placeholderButtonLabel() {
      return ConfigService.getMessageBoxPlaceholderButtonLabel();
    }

    get textFontSize() {
      if(ConfigService.getDefaultPanelTextFontSize() !== undefined){
        return { fontSize : ConfigService.getDefaultPanelTextFontSize()+'px !important'};
      } else{ // if user didn't define font size => use breakpoints of ChatView.vue
        return {}; 
      }
    }

    created(){
      EventBus.$on('ON_RESIZE_SCREEN_MODE', (isFullscreen: boolean) => {
        this.isFullscreenDisplay = isFullscreen;
      });
      this.isFullscreenDisplay = ResponsiveUiHelper.isFullscreenDisplay(this.vuetifyRef);
    }

    destroyed(){
      EventBus.$off('ON_RESIZE_SCREEN_MODE');
    }
  }
